<template>
  <div class="main_box">
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item"></div>
        </div>
        <div class="form_bar_btn">
          <el-button
            type="primary"
            @click="getQuestionnaireList()"
            size="small"
            plain
          >
            刷新
          </el-button>
          <el-button
            type="primary"
            @click="createQuestionnaire()"
            v-show="questionnaireItems.length > 0"
          >
            新增问卷
          </el-button>
          <el-button
            type="primary"
            @click="resultsSummary()"
            v-show="questionnaireItems.length > 0"
          >
            结果汇总
          </el-button>
          <!-- <el-button
            type="primary"
            @click="openClearMeetingData()"
            v-if="userRole === 1"
          >
            清除数据
          </el-button> -->
        </div>
      </div>
      <el-empty
        description="暂无问卷"
        v-loading="questionnaireListLoading"
        v-show="questionnaireItems.length === 0"
      >
        <el-button type="primary" @click="createQuestionnaire()">
          新增问卷
        </el-button>
      </el-empty>
      <el-table
        row-key="Id"
        :data="questionnaireItems"
        stripe
        ref="questionnaireItemsTable"
        style="width: 100%"
        v-loading="questionnaireListLoading"
        v-show="questionnaireItems.length > 0"
      >
        <el-table-column
          type="index"
          :index="questionnaireIndexMethod"
          label="序号"
          width="50"
          v-if="!is_xs"
        >
        </el-table-column>
        <el-table-column label="名称" min-width="140">
          <template slot-scope="scope">
            <el-link
              v-html="scope.row.Name"
              @click="lookQuestionnaire(scope.row.Id)"
            >
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="StrQuestionnaireType" label="类型" width="80">
        </el-table-column>
        <el-table-column prop="QuestinsNumber" label="题目数量" width="80">
        </el-table-column>
        <el-table-column prop="UsersNumber" label="答卷人" width="80">
        </el-table-column>
        <el-table-column prop="StrState" label="状态" width="80">
        </el-table-column>
        <el-table-column label="操作" width="300" align="right">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.State == 0"
              @click="editQuestionnaire(scope.row.Id)"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.State == 0"
              @click="deleteQuestionnaire(scope.row)"
            >
              删除
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.State == 0"
              @click="startQuestionnaire(scope.row)"
            >
              发布问卷
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.State == 1"
              @click="endQuestionnaire(scope.row)"
            >
              结束问卷
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="scope.row.State == 2"
              @click="colseQuestionnaire(scope.row)"
              title="关闭问卷后，答卷端不再显示当前问卷"
            >
              关闭问卷
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              v-if="
                userRole === 1 && (scope.row.State == 1 || scope.row.State == 2)
              "
              @click="resetQuestionnaire(scope.row)"
            >
              重启问卷
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click="questionnaireWatch(scope.row)"
            >
              问卷监控
            </el-link>
            <el-link
              title="点击复制问卷链接"
              v-clipboard:copy="
                scope.row.AnswerLogin +
                '/' +
                companyId +
                '/' +
                scope.row.MeetingID +
                '/' +
                scope.row.Id
              "
              v-clipboard:success="cliSuccess"
              v-clipboard:error="cliEooro"
              style="margin: 0px 10px"
            >
              <i class="el-icon-copy-document"></i>
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="questionnaireListQuery.maxResultCount"
        :layout="pagination_layout"
        :total="questionnaireTotalCount"
        v-show="questionnaireItems.length > 0"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import questionnaireApi from '../../../../api/wj/questionnaire'
import Sortable from 'sortablejs'
export default {
  name: 'questionnaireList',
  components: {
  },
  data () {
    return {
      questionnaireListLoading: true,
      questionnaireTotalCount: 0,
      questionnaireListQuery: {
        meetingId: null,
        maxResultCount: 10,
        skipCount: 0
      },
      currentPage: 1,
      pagination_layout: 'prev, pager, next',
      questionnaireItems: [],
      userRole: -1,
      companyId: null
    }
  },
  props: ['questionnaireListPagingQuery'],
  methods: {
    getQuestionnaireList: function () {
      const _this = this
      _this.questionnaireListLoading = true
      questionnaireApi.getQuestionnaireList({
        meetingId: _this.questionnaireListQuery.meetingId,
        skipCount: _this.questionnaireListQuery.skipCount,
        maxResultCount: _this.questionnaireListQuery.maxResultCount
      }).then(data => {
        _this.questionnaireItems = data.Items
        _this.questionnaireTotalCount = data.TotalCount
        _this.companyId = data.CompanyId
        _this.$nextTick(function () {
          _this.$refs.questionnaireItemsTable.doLayout()
        })
        _this.questionnaireListLoading = false
      }).catch(err => {
        _this.questionnaireListLoading = false
        return err
      })
    },
    questionnaireIndexMethod (index) {
      return index + this.questionnaireListQuery.skipCount + 1
    },
    handleSizeChange (val) {
      this.questionnaireListQuery.maxResultCount = val
      this.$emit('changePaging', this.questionnaireListQuery.skipCount, this.questionnaireListQuery.maxResultCount, this.currentPage)
      this.getQuestionnaireList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.questionnaireListQuery.skipCount = (val - 1) * this.questionnaireListQuery.maxResultCount
      this.$emit('changePaging', this.questionnaireListQuery.skipCount, this.questionnaireListQuery.maxResultCount, this.currentPage)
      this.getQuestionnaireList()
    },
    createQuestionnaire: function () {
      this.$router.push({ name: 'createQuestionnaire', params: { mid: this.$route.params.mid, qid: '0' } })
    },
    editQuestionnaire: function (questionnaireId) {
      this.$router.push({ name: 'editQuestionnaire', params: { mid: this.$route.params.mid, qid: questionnaireId } })
    },
    lookQuestionnaire: function (questionnaireId) {
      this.$router.push({ name: 'editQuestionnaire', params: { mid: this.$route.params.mid, qid: questionnaireId } })
    },
    deleteQuestionnaire: function (item) {
      this.$confirm('确认删除问卷“' + item.Name + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        questionnaireApi.deleteQuestionnaire({
          questionnaireId: item.Id
        }).then(data => {
          openLoading.close()
          this.getQuestionnaireList()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    startQuestionnaire: function (item) {
      this.$confirm('确认发布问卷“' + item.Name + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('问卷发布中…')
        questionnaireApi.startQuestionnaire({
          questionnaireId: item.Id
        }).then(data => {
          openLoading.close()
          this.getQuestionnaireList()
          this.$message({
            type: 'success',
            message: item.Name + ' 问卷发布成功！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消问卷发布操作',
          customClass: 'custom_message'
        })
      })
    },
    endQuestionnaire: function (item) {
      this.$confirm('确认结束问卷“' + item.Name + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('问卷结束中…')
        questionnaireApi.endQuestionnaire({
          questionnaireId: item.Id
        }).then(data => {
          openLoading.close()
          this.getQuestionnaireList()
          this.$message({
            type: 'success',
            message: item.Name + ' 问卷已经结束！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消结束问卷操作',
          customClass: 'custom_message'
        })
      })
    },
    colseQuestionnaire: function (item) {
      this.$confirm('确认关闭问卷“' + item.Name + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('问卷关闭中…')
        questionnaireApi.colseQuestionnaire({
          questionnaireId: item.Id
        }).then(data => {
          openLoading.close()
          this.getQuestionnaireList()
          this.$message({
            type: 'success',
            message: item.Name + ' 问卷已经关闭！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消关闭问卷操作',
          customClass: 'custom_message'
        })
      })
    },
    resetQuestionnaire: function (item) {
      this.$confirm('确认重置问卷“' + item.Name + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('问卷重置中…')
        questionnaireApi.resetQuestionnaire({
          questionnaireId: item.Id
        }).then(data => {
          openLoading.close()
          this.getQuestionnaireList()
          this.$message({
            type: 'success',
            message: item.Name + ' 问卷重置成功！',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置问卷操作',
          customClass: 'custom_message'
        })
      })
    },
    questionnaireWatch: function (item) {
      this.$router.push({ name: 'watchQuestionnaire', params: { mid: this.$route.params.mid, qid: item.Id } })
    },
    resultsSummary: function () {
      this.$router.push({ name: 'questionnaireResultsSummary', params: { mid: this.$route.params.mid } })
    },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    },
    openClearMeetingData: function () {

    },
    setSort () {
      const _this = this
      const el = _this.$refs.questionnaireItemsTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      Sortable.create(el, {
        onEnd: evt => {
          const sortItems = []
          if (evt.oldIndex > evt.newIndex) {
            const sortItem = {}
            sortItem.QuestionnaireId = _this.questionnaireItems[evt.oldIndex].Id
            sortItem.Sort = _this.questionnaireItems[evt.newIndex].Sort
            sortItem.Name = _this.questionnaireItems[evt.oldIndex].Name
            sortItems.push(sortItem)
            for (let i = evt.newIndex; i < evt.oldIndex; i++) {
              const sortItem = {}
              sortItem.QuestionnaireId = _this.questionnaireItems[i].Id
              sortItem.sort = _this.questionnaireItems[i].Sort - 1
              sortItem.Name = _this.questionnaireItems[i].Name
              sortItems.push(sortItem)
            }
          }
          if (evt.oldIndex < evt.newIndex) {
            const sortItem = {}
            sortItem.QuestionnaireId = _this.questionnaireItems[evt.oldIndex].Id
            sortItem.Sort = _this.questionnaireItems[evt.newIndex].Sort
            sortItem.Name = _this.questionnaireItems[evt.oldIndex].Name
            sortItems.push(sortItem)
            for (let i = evt.newIndex; i > evt.oldIndex; i--) {
              const sortItem = {}
              sortItem.QuestionnaireId = _this.questionnaireItems[i].Id
              sortItem.sort = _this.questionnaireItems[i].Sort + 1
              sortItem.Name = _this.questionnaireItems[i].Name
              sortItems.push(sortItem)
            }
          }
          // console.log(sortItems)
          const openLoading = this.openLoading()
          questionnaireApi.sortQuestionnaire(sortItems).then(data => {
            openLoading.close()
            this.getQuestionnaireList()
          }).catch(err => {
            openLoading.close()
            return err
          })
        }
      })
    },
    cliSuccess () {
      this.$message({
        type: 'success',
        message: '复制成功',
        customClass: 'custom_message'
      })
    },
    cliEooro () {
      this.$message({
        type: 'error',
        message: '复制失败',
        customClass: 'custom_message'
      })
    }

  },
  computed: {

  },
  mounted () {
    if (!this.is_xs) {
      this.setSort()
    }
  },
  created () {
    this.questionnaireListQuery.meetingId = this.$route.params.mid
    this.questionnaireListQuery.skipCount = this.questionnaireListPagingQuery.skipCount
    this.questionnaireListQuery.maxResultCount = this.questionnaireListPagingQuery.maxResultCount
    this.currentPage = this.questionnaireListPagingQuery.currentPage
    this.getQuestionnaireList()
    this.getCurrentUserRole()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
</style>
